import { motion } from 'framer-motion';
import { useRef } from 'react';
import { useInView } from 'framer-motion';
import { UserPlus, Target, LineChart } from 'lucide-react';

const steps = [
  {
    num: '01',
    icon: UserPlus,
    title: 'Créez votre profil',
    desc: "Téléchargez l'app, choisissez votre discipline et commencez votre essai gratuit de 7 jours.",
  },
  {
    num: '02',
    icon: Target,
    title: 'Enregistrez vos sessions',
    desc: "Saisissez vos scores en direct ou après la session. Ajoutez la météo, l'équipement, le lieu.",
  },
  {
    num: '03',
    icon: LineChart,
    title: 'Analysez et progressez',
    desc: 'Visualisez vos tendances, identifiez vos faiblesses et suivez votre progression dans le temps.',
  },
];

export default function HowItWorks() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section data-testid="how-it-works-section" className="py-24 sm:py-32 relative bg-[#0D0D0D]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" ref={ref}>
        <div className="text-center mb-16">
          <motion.span
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="text-[#FF6B35] text-sm font-semibold uppercase tracking-widest font-['Poppins']"
          >
            Comment ça marche
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            className="text-white font-['Poppins'] font-bold text-3xl sm:text-4xl mt-3"
          >
            Trois étapes simples
          </motion.h2>
        </div>

        <div className="relative grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12">
          <div className="hidden lg:block absolute top-[60px] left-[16.6%] right-[16.6%] h-px bg-gradient-to-r from-transparent via-[#FF6B35]/30 to-transparent" />
          {steps.map((step, i) => {
            const Icon = step.icon;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                animate={isInView ? { opacity: 1, y: 0 } : {}}
                transition={{ duration: 0.5, delay: i * 0.2 }}
                data-testid={`step-${i + 1}`}
                className="relative text-center"
              >
                <div className="relative inline-flex items-center justify-center w-[72px] h-[72px] rounded-2xl bg-[#1A1A1A] border border-white/5 mb-6 mx-auto group hover:border-[#FF6B35]/30 transition-all duration-300">
                  <Icon size={28} className="text-[#FF6B35]" />
                  <span className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-gradient-to-r from-[#FF6B35] to-[#FF8A5B] text-white text-xs font-bold flex items-center justify-center font-['Poppins']">
                    {step.num.slice(-1)}
                  </span>
                </div>
                <h3 className="text-white font-['Poppins'] font-bold text-xl mb-3">{step.title}</h3>
                <p className="text-[#A0A0A0] text-sm leading-relaxed max-w-xs mx-auto">{step.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
